import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const PhoneVerificationContext = createContext(null);

export function PhoneVerificationProvider({ children }) {
  const [refreshKey, setRefreshKey] = useState(0);

  const refreshPhoneVerification = useCallback(() => {
    setRefreshKey((key) => key + 1);
  }, []);

  const value = useMemo(
    () => ({ refreshKey, refreshPhoneVerification }),
    [refreshKey, refreshPhoneVerification]
  );

  return (
    <PhoneVerificationContext.Provider value={value}>
      {children}
    </PhoneVerificationContext.Provider>
  );
}

export function usePhoneVerification() {
  return (
    useContext(PhoneVerificationContext) ?? {
      refreshKey: 0,
      refreshPhoneVerification: () => { },
    }
  );
}
